export default __webpack_public_path__ + "static/media/createAccount.daa4a8f0.svg";